module.exports = __webpack_public_path__ + "img/ordPeeling2.637f1aa5.jpg";